import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { compose } from "redux";

import { completeRequisition } from "redux/modules/common/building/requisition/thunks/completeRequisition";

import { useConfirmModal } from "entities/ConfirmationModal/ConfirmationContext";

interface IProps {
  canCompleteRequisition: boolean;
  styles: Record<string, string>;
}

export const useFinishRequisitionTEMP = ({ canCompleteRequisition, styles }: IProps) => {
  const dispatch = useDispatch();

  const handleCompleteRequisition = useCallback(() => {
    if (!canCompleteRequisition) return;
    compose(dispatch, completeRequisition)();
  }, [canCompleteRequisition]);

  const { openConfirmModal, closeConfirmModal } = useConfirmModal();

  const openCompleteRequisitionDialog = () => {
    openConfirmModal({
      isOpen: true,
      onClose: closeConfirmModal,
      action: () => {
        handleCompleteRequisition();
        closeConfirmModal();
      },
      title: "Завершить заявку?",
      acceptButtonText: "Завершить",
      variant: "secondary",
      children: (
        <>
          Вы действительно хотите завершить заявку? <br />
          После завершения заявка перейдёт в статус "Исполнена"
        </>
      ),
      className: styles.confirmModal,
    });
  };

  return {
    openCompleteRequisitionDialog,
  };
};
